export const REQUEST_MASTER_CUISINES = "REQUEST_MASTER_CUISINES";
export const SET_MASTER_CUISINES = "SET_MASTER_CUISINES";
export const ERROR_GET_MASTER_CUISINES = "ERROR_GET_MASTER_CUISINES";

export const REQUEST_MASTER_CUISINES_CATEGORIES =
  "REQUEST_MASTER_CUISINES_CATEGORIES";
export const SET_MASTER_CUISINES_CATEGORIES = "SET_MASTER_CUISINES_CATEGORIES";
export const ERROR_GET_MASTER_CUISINES_CATEGORIES =
  "ERROR_GET_MASTER_CUISINES_CATEGORIES";

export const REQUEST_CREATE_MASTER_CUISINES = "REQUEST_CREATE_MASTER_CUISINES";
export const SUCCESS_CREATE_MASTER_CUISINES = "SUCCESS_CREATE_MASTER_CUISINES";
export const ERROR_CREATE_MASTER_CUISINES = "ERROR_CREATE_MASTER_CUISINES";

export const REQUEST_UPDATE_MASTER_CUISINES = "REQUEST_UPDATE_MASTER_CUISINES";
export const SUCCESS_UPDATE_MASTER_CUISINES = "SUCCESS_UPDATE_MASTER_CUISINES";
export const ERROR_UPDATE_MASTER_CUISINES = "ERROR_UPDATE_MASTER_CUISINES";

export const REQUEST_DELETE_MASTER_CUISINES = "REQUEST_DELETE_MASTER_CUISINES";
export const SUCCESS_DELETE_MASTER_CUISINES = "SUCCESS_DELETE_MASTER_CUISINES";
export const ERROR_DELETE_MASTER_CUISINES = "ERROR_DELETE_MASTER_CUISINES";

export const SET_MESSAGE_MASTER_CUISINES = "SET_MESSAGE_MASTER_CUISINES";
